import { useNavigate } from "react-router-dom";
import Modal from "../../../components/portal/Modal";
import successIcon from "../../../assets/icons/successIcon.svg";
import GradientButton from "../../../components/UI/buttonUI/GradientButton";

const UpdateAdminsRolesSuccessDialog = ({ msg }) => {
  const navigate = useNavigate();
  return (
    <Modal modalWidth="max-w-lg w-11/12 max-sm:w-95% max-md:p-4 pb-8 pt-7 px-8 text-center">
      <img src={successIcon} alt="messageIcon" className="mx-auto mb-1 w-9" />
      <p className="view-success-msg-d py-4">{msg}</p>
      <GradientButton
        btnText="Ok"
        width="w-28"
        onClick={() => navigate("/user/all")}
      />
    </Modal>
  );
};

export default UpdateAdminsRolesSuccessDialog;
